/* eslint-disable @typescript-eslint/naming-convention */
export const SET_NOTIFICATION = "@NOTIFICATIONS/SET_NOTIFICATION";
export type SET_NOTIFICATION = typeof SET_NOTIFICATION;

export const PURGE_NOTIFICATIONS = "@NOTIFICATIONS/PURGE_NOTIFICATIONS";
export type PURGE_NOTIFICATIONS = typeof PURGE_NOTIFICATIONS;

export const SHOW_HIDE_NOTIFICATIONS = "@NOTIFICATIONS/SHOW_HIDE_NOTIFICATIONS";
export type SHOW_HIDE_NOTIFICATIONS = typeof SHOW_HIDE_NOTIFICATIONS;

export const MARK_AS_READ = "@NOTIFICATIONS/MARK_AS_READ";
export type MARK_AS_READ = typeof MARK_AS_READ;

export const MARK_AS_DISMISSED = "@NOTIFICATIONS/MARK_AS_DISMISSED";
export type MARK_AS_DISMISSED = typeof MARK_AS_DISMISSED;
